import { render } from "./CIS-FAQ.vue?vue&type=template&id=68ccc094"
import script from "./CIS-FAQ.vue?vue&type=script&lang=js"
export * from "./CIS-FAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__